module.exports = __webpack_public_path__ + "img/platform_company.7ead0154.png";